import initAccordions from './accordion.js';
import { parallaxBg } from './bg-parallax.js';
import customSlider from './custom-slider.js';
import { infiniteLoopAnimation } from './infinite-scrolling-logos.js';
import languageSwitcher from './language-switcher.js';
import initCustomerLogos from './logo-rotation.js';
import { triggerHeaderScroll } from './menu-bar.js';
import { initScrollDirectionIndicator } from './menu-scroll-direction.js';
import { handleMobMenu } from './mob-menu.js';
import initNavSubMenus from './nav-menu.js';
import initPricingCalc from './pricing-calculator.js';
import initTabsSections from './section-tabs.js';
import { initVideoModals } from './video-modal.js';
import initPricingFormModal from './pricing-contact-form-modal.js';
import initTooltips from './tooltips.js';
import { initTabsModal } from './image-modal.js';

window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.no-transitions').forEach((el) => {
        el.classList.remove('no-transitions');
    });

    initNavSubMenus();
    triggerHeaderScroll();
    initScrollDirectionIndicator();
    handleMobMenu();

    /* Components */
    initCustomerLogos();
    initAccordions();
    customSlider();
    initPricingCalc();
    infiniteLoopAnimation();
    languageSwitcher();
    parallaxBg();
    initPricingFormModal();
    initTooltips();

    initTabsModal();

    setTimeout(() => {
        initVideoModals();
        if (document.querySelector('.video-modal-button')) {
            document.addEventListener('facetwp-loaded', function () {
                initVideoModals();
            });
        }

        initTabsSections();
    }, 500);
});